// src/components/Signals/SignalDetail.js
import React, { useEffect, useRef } from 'react';
import styles from './Signals.css';

const SignalDetail = ({ ads = [], captions = [], selectedImage = '' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!selectedImage) return;
    const el = document.getElementById(`signal-${selectedImage}`);
    if (el && containerRef.current) {
      containerRef.current.scrollTo({
        top: el.offsetTop - 80,
        behavior: 'smooth',
      });
    }
  }, [selectedImage]);

  return (
    <main ref={containerRef} className={styles.signalDetailPage}>
      {ads.map((ad, index) => {
        const filename = ad.imageUrl.split('/').pop();
        const captionEntry = captions.find(c => c.imageUrl.includes(filename)) || {};

        return (
          <section
            key={index}
            id={`signal-${filename}`}
            className={styles.signalDetailItem}
          >
            <img src={ad.imageUrl} alt={ad.brand} onError={(e) => e.target.style.opacity = 0.3} />
            <div className={styles.signalDetailContent}>
              <h2>{ad.brand}</h2>
              <p>{captionEntry.caption || 'No caption provided.'}</p>
              <div className={styles.signalCaptionButtons}>
                <button onClick={() => alert(`Saved ${ad.brand}`)}>Save</button>
                <button onClick={() => window.open(ad.sourceUrl, '_blank')}>View</button>
              </div>
            </div>
          </section>
        );
      })}
    </main>
  );
};

export default SignalDetail;
